<template>
    <QuestionAbstract>

        <template #title>
            {{ formattedQuestion }}
        </template>

        <template #content>

            <div class="question-scale">

                <div>{{ minLabel }}</div>

                <v-radio-group 
                    inline 
                    hide-details
                    v-model="answer">
                    <v-radio 
                        v-for="option in count" 
                        color="color1"
                        :label="String(option)" 
                        :value="option">
                    </v-radio>
                </v-radio-group>

                <div>{{ maxLabel }}</div>
            </div>

        </template>

    </QuestionAbstract>
</template>

<script>
import QuestionAbstract from '@/components/survey/question/QuestionAbstract.vue'

export default {
    name: 'QuestionScale',
    components: {
        QuestionAbstract
    },
    props: {
        index: {
            type: Number,
            required: true
        },
        question: {
            type: String,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            answer: null
        }
    },
    computed: {
        formattedQuestion() {
            return `${this.index + 1}. ${this.question}`
        },
        count() {
            return this.options?.count
        },
        minLabel() {
            return this.options?.minLabel || ''
        },
        maxLabel() {
            return this.options?.maxLabel || ''
        },
    },
    watch: {
        answer(newValue, oldValue) {
            if (newValue === oldValue) return
            this.handleAnswer()
        }
    },
    emits: ['answer'],
    methods: {
        handleAnswer() {
            this.$emit('answer', this.index, this.answer)
        }
    }
}
</script>

<style scoped>
.question-scale {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}

.question-scale .v-radio {
    margin-right: 10px;
}

@media (max-width: 1000px) {
    .question-scale {
        gap: 10px;
    }

    .question-scale .v-radio {
        margin-right: 0px;
    }
}

@media (max-width: 800px) {
    .question-scale {
        margin-top: 10px;
        margin-left: 10px;
        flex-direction: column;
        justify-content: center;
    }
}
</style>